export default __webpack_public_path__ + "static/media/github.19b150eb.svg";